import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.scss";
import logo from "../../assets/images/white-logo.svg";
import dashboard from '../../assets/images/sidebar/dashboard.svg';
import forms from '../../assets/images/sidebar/forms.svg';
import logout from '../../assets/images/logout.png';
import { useNavigate, Link } from "react-router-dom";
import { handleConfirmation } from "../../utils/confirm";
import hestailogo from "../../assets/transp.png";

const AgentSidebar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    handleConfirmation(() => {
      navigate("/logout");
    }, () => {
      return false
    })
  };

  return (
    <div className="sidebar">
      <div className="sidebar-inner">
        <div className="logo">
          <img src={hestailogo} className="sidebar-logo" />
        </div>
        <div className="module-name">
          Agent Portal
        </div>
        <div className="menu-links">
          <ul>
            <li>
              <NavLink exact={true} className={({ isActive }) => isActive ? "active" : ''} to='/agent/dashboard'>
                <img src={dashboard} />
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink className={({ isActive }) => isActive? "active": ''} to='/agent/ticket/open'>
                <img src={forms} />
                <span>Open Ticket</span>
              </NavLink>
            </li>
            <li>
              <NavLink className={({ isActive }) => isActive ? "active" : ''} to='/agent/ticket/closed'>
                <img src={forms} />
                <span>Closed Ticket</span>
              </NavLink>
            </li>
            <li>
              <Link className={({ isActive }) => isActive ? "active" : ''} onClick={handleLogout}>
                <img src={logout} />
                <span>Logout</span>
              </Link>
            </li>
          </ul>
          <div className="bottom-text">
            <p>© Liaise. All Rights Reserved. V.1.0.0 (Beta)</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentSidebar;
